module.exports = __webpack_public_path__ + "media/images/lb/105-3e0c134d6b8bb82935678d621fb5f85e.svg";